
class Article extends HTMLElement {
    constructor() {
        super();

        this.findAllTitle();
        this.removeBrTags();
    }

    removeBrTags() {
        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;br&gt;", "");
        });

        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;span&gt;", "");
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;/span&gt;", "");
        });

        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;strong&gt;", "");
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;/strong&gt;", "");
        });

        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;b&gt;", "");
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;/b&gt;", "");
        });
        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll("&nbsp;", "");
        });
        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;i&gt;", "");
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;/i&gt;", "");
        });
        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll('&lt;span style="font-weight: 400;"&gt;', '');
        });

        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll('&lt;strong data-mce-fragment="1"&gt;', '');
        });
    }

    getRandomIndices(length) {
        let index1 = Math.floor(Math.random() * length);
        let index2;

        do {
            index2 = Math.floor(Math.random() * length);
        } while (index2 === index1);

        return [index1, index2];
    }

    initEvents() {
        document.querySelectorAll(".sommaire__link").forEach((button) => {
            button.addEventListener("click", this.buttonScrollTo.bind(this));
        });
    }


    findAllTitle() {
        let titles = [];

        let id = 0;

        const content = document.querySelector(".article__content");
        let sommaire = document.querySelector(".article__table-sommaire");

        content.querySelectorAll("h3").forEach((elem) => {
            elem.classList.add(`content-h3`);
        });

        content.querySelectorAll("h3, h2").forEach((elem) => {
            elem.classList.add(`title${id}`);

            if (elem.classList.contains("content-h3")) {
                let nouvelElement = {
                    title: elem,
                    booleanValue: true,
                };
                id += 1;
                titles.push(nouvelElement);
            } else {
                let nouvelElement = {
                    title: elem,
                    booleanValue: false,
                };
                id += 1;
                titles.push(nouvelElement);
            }
        });

        for (var i = 0; i < titles.length; i++) {
            var li = document.createElement("li");
            var div = document.createElement("div");
            div.setAttribute("data-info", i);
            div.classList.add("sommaire__link");
            if (titles[i].booleanValue == true) {
                div.classList.add("sommaire__link-h3");
            }
            div.textContent = titles[i].title.innerHTML;
            li.appendChild(div);
            sommaire.appendChild(li);
        }

        this.initEvents();
    }

    buttonScrollTo(e) {
        let currentLink = e.currentTarget;
        let currentId = currentLink.dataset.info;
        let section = document.querySelector(`.title${currentId}`);
        let scrollTop = section.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 80;

        window.scrollTo({ top: scrollTop, left: 0, behavior: 'smooth' });
    }
}

customElements.define("article-js", Article);
